import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1',
    desc: 'Historia Clínica, Anamnesis & Marco Legal AR',
    color: 'from-blue-500/20 to-transparent',
    border: 'border-t-blue-500'
  }, {
    icon: '📗',
    title: 'Tomo 2',
    desc: 'Educación Alimentaria & Material para Pacientes',
    color: 'from-green-500/20 to-transparent',
    border: 'border-t-green-500'
  }, {
    icon: '📙',
    title: 'Tomo 3',
    desc: 'Recetarios Estacionales Argentinos (+80 recetas)',
    color: 'from-orange-500/20 to-transparent',
    border: 'border-t-orange-500'
  }, {
    icon: '📕',
    title: 'Tomo 4',
    desc: 'Patologías Prevalentes: DBT2, HTA, Celiaquía, HGNA, SII y más',
    color: 'from-red-500/20 to-transparent',
    border: 'border-t-red-500'
  }, {
    icon: '📓',
    title: 'Tomo 5',
    desc: 'Deporte, Suplementación & Antropometría',
    color: 'from-gray-400/20 to-transparent',
    border: 'border-t-gray-400'
  }, {
    icon: '📔',
    title: 'Tomo 6',
    desc: 'Marketing, Gestión del Consultorio & Scripts WhatsApp',
    color: 'from-yellow-500/20 to-transparent',
    border: 'border-t-yellow-500'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-6xl mx-auto" data-id="element-394">
      <FadeIn data-id="element-395">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-396">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]" data-id="element-397">
            📚
          </span>{' '}
          LOS 6 TOMOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-398">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-399">
            <motion.div whileHover={{
          y: -5,
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} className={`bg-gray-900/80 backdrop-blur-sm border border-gray-800 ${tomo.border} border-t-4 hover:border-gray-600 transition-all rounded-2xl p-4 md:p-8 h-full flex flex-col relative overflow-hidden shadow-lg hover:shadow-2xl`} data-id="element-400">
              <div className={`absolute inset-0 bg-gradient-to-b ${tomo.color} opacity-30 pointer-events-none`} data-id="element-401"></div>

              <div className="absolute top-3 right-3 md:top-4 md:right-4 text-[10px] md:text-xs font-black tracking-widest text-gray-500 bg-gray-950 px-2 py-0.5 md:px-3 md:py-1 rounded-full border border-gray-800" data-id="element-402">
                TOMO 0{index + 1}
              </div>

              <div className="text-4xl md:text-6xl mb-3 md:mb-6 relative z-10 drop-shadow-xl" data-id="element-403">
                {tomo.icon}
              </div>

              <h3 className="text-lg md:text-2xl font-bold text-white mb-1.5 md:mb-3 relative z-10" data-id="element-404">
                {tomo.title}
              </h3>

              <p className="text-sm md:text-base text-gray-400 font-medium leading-relaxed flex-grow relative z-10" data-id="element-405">
                {tomo.desc}
              </p>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}